import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import p from "../../Button/Button.js";
import { Typography as a } from "../../Typography/Typography.js";
import e from "./NewFileUpload.module.scss.js";
import { useState as d } from "react";
import { clsx as x } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { i18n as l } from "../../../../utils/locale/locale.js";
const y = ({
  descriptionMessage: o,
  width: i = "100%x",
  isDragActive: m,
  disabled: r
}) => {
  const [n, s] = d(!1);
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsxs(
      "div",
      {
        style: { width: i },
        "aria-disabled": r,
        className: x(e.compactStyle, {
          [e.drag]: m,
          [e.disabled]: r
        }),
        onMouseEnter: () => s(!0),
        onMouseLeave: () => s(!1),
        children: [
          /* @__PURE__ */ t.jsx(
            a,
            {
              textColor: "color/fg/lightest",
              text: l("drop_to_upload")
            }
          ),
          /* @__PURE__ */ t.jsx(
            p,
            {
              variant: n ? "outlined" : "tinted",
              label: l("browse_files"),
              size: "small",
              className: "w-[70px]"
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
      a,
      {
        className: "mt-100 !mb-100",
        variant: "interface/default/s",
        text: o,
        textColor: "color/fg/lighter"
      }
    ) })
  ] });
};
export {
  y as default
};
//# sourceMappingURL=CompactFileUpload.js.map
